import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { BookMockup } from './BookMockup';
import { CART_URL } from './constants';
import { trackAddToCart } from './MetaPixel';
import { useCurrency } from './currency/CurrencyContext';
export function Hero() {
  const {
    buildCartUrl
  } = useCurrency();
  return <section id="inicio" className="overflow-hidden bg-[#fffaf0] px-5 pb-16 pt-10 sm:px-8 sm:pb-24 lg:pt-16" data-id="element-112" data-mp="4n9z0lnv3m4r">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1.08fr_0.92fr] lg:gap-16" data-id="element-113" data-mp="1274orr9pfk8a">
        <div className="max-w-3xl" data-id="element-114" data-mp="sbb2hg66ocdb">
          <p className="inline-flex items-center rounded-full border border-[#bad1ba] bg-[#e8f0df] px-3 py-1.5 text-xs font-bold uppercase tracking-[0.12em] text-[#27573c]" data-id="element-115" data-mp="sai16upzuf2k">
            Tu semana, resuelta en una tarde
          </p>
          <h1 className="font-display mt-5 text-5xl font-black leading-[0.94] tracking-[-0.055em] text-[#143827] sm:text-6xl lg:text-7xl" data-id="element-116" data-mp="3d2tnz8hi2ie0">
            🔥 Dile adiós al estrés de cocinar todos los días.
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-[#435a4a] sm:text-xl" data-id="element-117" data-mp="3j6obvk13emq3">
            Organiza todas tus comidas de la semana en solo{' '}
            <strong className="font-extrabold text-[#183d2b]" data-id="element-118" data-mp="399bcfr77pjxk">2 horas</strong>.
            Con Meal Prep Club aprenderás a cocinar una sola vez y disfrutar
            comidas saludables toda la semana, incluso si tienes muy poco tiempo
            o nunca has hecho meal prep.
          </p>
          <a href={buildCartUrl(CART_URL)} onClick={trackAddToCart} className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#a92d3d] px-6 py-4 text-base font-extrabold text-white shadow-[0_7px_0_#6d1725] transition-[background-color,transform] duration-150 hover:-translate-y-0.5 hover:bg-[#8d2130] active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-[#f0b8c0] sm:w-auto sm:px-8" data-id="element-119" data-mp="359t19n570n7x">
            +1000 recetas + 5 bonos gratis{' '}
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-120" data-mp="s2tdvmncibq9" />
          </a>
          <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-3 text-sm text-[#496150]" data-id="element-121" data-mp="naa12rwhfkmi">
            <div className="flex items-center gap-1 text-[#c33d4c]" aria-label="Cinco de cinco estrellas" data-id="element-122" data-mp="id9vei3jojvx">
              <StarIcon className="h-4 w-4 fill-current" data-id="element-123" data-mp="dbaowzcid6ur" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-124" data-mp="1azkufobi6cqm" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-125" data-mp="1622irq63pjex" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-126" data-mp="162m0b5rua5sf" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-127" data-mp="111ycsu2tk72y" />
            </div>
            <span className="font-semibold" data-id="element-128" data-mp="x14ldqq64a5b">
              Una rutina más ligera empieza hoy
            </span>
            <span className="flex items-center gap-1.5" data-id="element-129" data-mp="3ltgmlp4rwont">
              <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-[#30714a]" data-id="element-130" data-mp="3lquenodz0752" />
              Acceso inmediato
            </span>
          </div>
        </div>
        <div className="relative mx-auto flex w-full max-w-md justify-center py-5 lg:max-w-none" data-id="element-131" data-mp="1x7hub9ezzuyr">
          <div className="absolute bottom-0 left-1/2 h-10 w-72 -translate-x-1/2 rounded-[100%] bg-[#d9e5cc]" aria-hidden="true" data-id="element-132" data-mp="218jvvwwe0j3w" />
          <BookMockup data-id="element-133" data-mp="2b1hjghg8ky9d" />
          <div className="absolute bottom-8 -left-1 rounded-xl border border-[#ecd6ae] bg-[#fffdf7] px-3 py-2 shadow-lg sm:left-4" aria-hidden="true" data-id="element-134" data-mp="2b2smgf1uy1zf">
            <p className="text-[10px] font-bold uppercase tracking-wider text-[#71816f]" data-id="element-135" data-mp="2kx2f7xupp2ao">
              Incluye
            </p>
            <p className="text-sm font-extrabold text-[#183d2b]" data-id="element-136" data-mp="2oynwdvea42qo">
              +1000 recetas
            </p>
          </div>
          <div className="absolute right-0 top-7 rounded-xl bg-[#183d2b] px-3 py-2 text-center text-[#fff9ed] shadow-lg sm:right-6" aria-hidden="true" data-id="element-137" data-mp="umzg9pwb9u4p">
            <p className="text-[10px] font-bold uppercase tracking-wider text-[#c5dfbb]" data-id="element-138" data-mp="4b47zvkw08ki">
              Método
            </p>
            <p className="font-display text-lg font-black leading-none" data-id="element-139" data-mp="3vgnhcrzf7vqu">
              2 horas
            </p>
          </div>
        </div>
      </div>
    </section>;
}